export default "__VITE_ASSET__a2c8f7f8__"